
const FooterCopyright = () => {
  return (
    <>
      {/* Vastuuvapauslauseke */}
      <div className="mt-8 pt-6 border-t border-blue-700">
        <p className="text-blue-200 text-xs md:text-sm max-w-3xl mx-auto text-center px-4 md:px-0">
          Lainasampo.fi on lainojen vertailupalvelu, eikä itse myönnä lainoja. Tarjoamme asiakkaillemme 
          mahdollisuuden kilpailuttaa lainatarjouksia useilta pankeilta ja rahoituslaitoksilta helposti ja veloituksetta.
          Palvelumme on SSL-suojattu ja kaikki tiedot käsitellään turvallisesti.
        </p>
      </div>
      
      {/* Copyright with animation */}
      <div className="mt-6 text-center">
        <p className="text-blue-300 text-xs md:text-sm inline-block relative hover-scale">
          &copy; 2025 Lainasampo.fi. Kaikki oikeudet pidätetään.
        </p>
      </div>
    </>
  );
};

export default FooterCopyright;
